import React, { useEffect, Component, Fragment } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from 'highcharts/highcharts-more'
import { AlarmColor } from "../../datas/ColorData";
import { FxmsEvent } from "../../actions/FxEvent";
import { FxmsData } from "../../datas/FxData";
import { AttrListEdit } from "../../datas/OpClass";
import { FxDashEditInfo } from "../FxDashBoard";

HighchartsMore(Highcharts)

class High extends Component {

  render() {

    const { title, psItem, datas, fxUiGrpItem } = this.props;

    const minVal = psItem ? psItem.minVal : 0;
    const maxVal = psItem ? psItem.maxVal : 100;
    const psUnit = psItem ? psItem.psUnit : '';
    const psName = psItem ? psItem.psName : '';
    const height = fxUiGrpItem.uiHght > 400 ? fxUiGrpItem.uiHght : 400;
    let plotBands = [];
    let num = maxVal - minVal;
    let war = parseInt(num * .5 + minVal);
    let min = parseInt(num * .6 + minVal);
    let maj = parseInt(num * .7 + minVal);
    let cri = parseInt(num * .8 + minVal);

    function add(from, to, color) {
      return {
        from: from,
        to: to,
        color: color
      };
    }

    plotBands.push(add(war, min, AlarmColor.warning));
    plotBands.push(add(min, maj, AlarmColor.minor));
    plotBands.push(add(maj, cri, AlarmColor.major));
    plotBands.push(add(cri, maxVal, AlarmColor.critical));


    const options = {
      chart: {
        type: 'gauge',
        backgroundColor: 'rgba(255,255,255, 0.1)',
        plotBackgroundColor: 'rgba(255,255,255, 0.1)',
        // plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        // height : '100%'
        // width : '100%'
        // height: { height }
      },

      title: {
        text: title,
        style: { color: 'white' }
      },

      pane: {
        startAngle: -150,
        endAngle: 150,
        background: [{
          backgroundColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [[0, '#FFF'], [1, '#333']]
          },
          borderWidth: 0,
          outerRadius: '109%'
        }, {
          backgroundColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [[0, '#333'], [1, '#FFF']]
          },
          borderWidth: 1,
          outerRadius: '107%'
        }, {
          // default background
        }, {
          backgroundColor: '#DDD',
          borderWidth: 0,
          outerRadius: '105%',
          innerRadius: '103%'
        }]
      },

      // the value axis
      yAxis: {
        min: minVal,
        max: maxVal,

        minorTickInterval: 'auto',
        minorTickWidth: 1,
        minorTickLength: 10,
        minorTickPosition: 'inside',
        minorTickColor: '#666',

        tickPixelInterval: 30,
        tickWidth: 2,
        tickPosition: 'inside',
        tickLength: 10,
        tickColor: '#666',
        labels: {
          step: 2,
          rotation: 'auto'
        },
        title: {
          text: psUnit
        },
        plotBands: plotBands
      },

      series: [{
        name: psName,
        data: datas,
        tooltip: {
          valueSuffix: ' ' + psUnit
        }
      }]
    };
    return (
      <>
        <HighchartsReact
          containerProps={{ style: { height: "100%" } }}
          highcharts={Highcharts}
          options={options} />
      </>
    );
  }
}

/**
 * 게이지 챠트 설정
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @param {*} fxUiGrp 
 * @param {*} fxUiGrpItem 
 * @returns 
 */
export function FxRtGuageChartConfig( fxUiGrp, fxUiGrpItem) {
  const setList = new AttrListEdit("setting");
  setList.makeAttrSelect( 10, "moNo", "관리대상", 300, 'mo', { moClass: 'SENSOR' });
  setList.makeAttrSelect( 20, "psId", "수집항목", 300, 'psItem', { moClass: 'SENSOR' });
  setList.makeAttrButton( 30, "cmdApplyDb", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });
  return setList;
}


/**
 * 게이지 챠트
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @param {*} fxUiGrp 
 * @param {*} fxUiGrpItem 
 * @returns 
 */
export const FxRtGuageChart = props => {

  const { id, fxUiGrpItem, editable } = props;
  const [title, setTitle] = React.useState("noknown");
  const [psItem, setPsItem] = React.useState(null);
  const [mo, setMo] = React.useState({});
  const [datas, setDatas] = React.useState([0]);

  useEffect(() => {

    onFxmsEvent(fxUiGrpItem.attrObj);
    console.log("*** FxRtGuageChart *** mount " + id);

    return () => {
      FxmsEvent.removeEventListener(id);
      console.log("*** FxRtGuageChart *** unmount " + id);
    };
  }, []);


  useEffect(() => {
    if (mo === null || psItem === null) {
      return;
    }

    setTitle(mo.moName + "(" + psItem.psName + ")");
    FxmsEvent.addValuePeek(mo.moNo, psItem.psId, showData);

  }, [mo, psItem]);

  // id가 설정되어 있으면 다른 컴포넌트에서 보낸 이벤트를 받기위해 등록한다.
  if (id) {
    FxmsEvent.addEventListener(id, onFxmsEvent);
  }

  function showData(recvObj) {
    // 수집값을 보여준다.
    try {
      setDatas([recvObj.value]);
    } catch (e) {
      console.log(e);
    }
  }

  // 다른 컴포넌에서 보낸 이벤트를 받는 함수
  function onFxmsEvent(obj) {

    console.log("*** FxRtGuageChart ***", obj);

    if (obj) {

      try {
        if (obj.moNo) {
          FxmsData.getMo(obj.moNo).then(function (mo) {
            setMo(mo);
          });
        }
      } catch (e) {
        console.log(e);
      }

      try {
        if (obj.psId) {
          let psItem = FxmsData.getPsItem(obj.psId);
          if (psItem) setPsItem(psItem);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  if (editable) {
    return <FxDashEditInfo>게이지 챠트</FxDashEditInfo>;
  }

  return (
    <>
      <High title={title} mo={mo} psItem={psItem} datas={datas} fxUiGrpItem={fxUiGrpItem} />
    </>
  );
};

export default FxRtGuageChart;
